export default __webpack_public_path__ + "static/media/21.3c820a4c.jpg";